/* R&R checkout + gift confidence v6 — validates real gift line items before checkout. */
(() => {
  if (window.__rrCheckoutGiftConfidenceV6Loaded) return;
  window.__rrCheckoutGiftConfidenceV6Loaded = true;

  const PACKER_KEY = 'PACKER - FREE GIFT(S)';
  const GIFT_PREFIX = 'R&R Free Gift ';
  const NOTE_START = '[R&R FREE GIFT]';
  const NOTE_END = '[/R&R FREE GIFT]';
  const MAX_GIFTS = 12;
  const VALID_GIFTS = new Set([
    'Rubee Hand & Body Lotion - 2 oz','Rinju Hand & Body Lotion - 2 oz','Rinju Beauté Réelle Body and Hand Cream - 2 oz','Pierre La Touche Hand & Body Lotion - 2 oz'
  ]);
  const rootPath = () => window.Shopify?.routes?.root || '/';
  let checkoutBusy = false;
  let packerSyncPromise = null;
  let syncTimer = 0;
  let lastCart = null;

  function escapeHtml(value='') { return String(value).replace(/[&<>'"]/g,c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])); }
  function injectStyles() {
    if (document.getElementById('rr-gift-confidence-style')) return;
    const style=document.createElement('style'); style.id='rr-gift-confidence-style'; style.textContent=`
      .rr-gift-checkout-proof{margin:12px 0 10px;padding:14px 15px;border:2px solid #0033cc;border-radius:16px;background:#f4f6ff;color:#191a18;text-align:left}
      .rr-gift-checkout-proof__eyebrow{margin:0 0 5px;color:#0033cc;font:800 10px/1.2 var(--rr-label-font,Montserrat,Arial,sans-serif);letter-spacing:.11em}
      .rr-gift-checkout-proof__title{margin:0;font:700 13px/1.35 var(--rr-label-font,Montserrat,Arial,sans-serif)}
      .rr-gift-checkout-proof__list{display:grid;gap:5px;margin:9px 0 0;padding:0;list-style:none}.rr-gift-checkout-proof__list li{font:600 11px/1.4 var(--rr-label-font,Montserrat,Arial,sans-serif)}
      .rr-gift-checkout-proof__note{margin:8px 0 0;color:#5f625d;font:600 10px/1.4 var(--rr-label-font,Montserrat,Arial,sans-serif)}
      .rr-gift-checkout-proof__choose{width:100%;min-height:44px;margin-top:10px;border:0;border-radius:999px;background:#0033cc;color:#fff!important;-webkit-text-fill-color:#fff!important;font:700 12px/1 var(--rr-label-font,Montserrat,Arial,sans-serif);cursor:pointer}
      .rr-gift-checkout-proof.is-missing{border-color:#b54734;background:#fff4f0}.rr-gift-checkout-proof.is-missing .rr-gift-checkout-proof__eyebrow{color:#9b321f}
      [data-rr-checkout-busy="true"]{opacity:.72!important;pointer-events:none!important}
    `; document.head.append(style);
  }
  async function fetchCart() {
    const r=await fetch(`${rootPath()}cart.js`,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if(!r.ok) throw new Error('Could not read cart'); return r.json();
  }
  async function updateCartState(attributes,note) {
    const body={attributes};
    if(typeof note==='string') body.note=note;
    const r=await fetch(`${rootPath()}cart/update.js`,{method:'POST',credentials:'same-origin',cache:'no-store',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    if(!r.ok) throw new Error('Could not save fulfillment gift'); return r.json();
  }
  function earned(cart) { try{return Number(window.RRCaseGift?.entitlement?.(cart))||0;}catch{return 0;} }
  function selected(cart) {
    const attrs=cart?.attributes||{}, count=Math.min(earned(cart),MAX_GIFTS), gifts=[];
    for(let i=1;i<=count;i++){const raw=String(attrs[`${GIFT_PREFIX}${i}`]||'').trim();gifts.push(VALID_GIFTS.has(raw)?raw:'');}
    return gifts;
  }
  function firstMissing(cart){const i=selected(cart).findIndex(v=>!v);return i===-1?null:i+1;}
  function packerSummary(cart){const gifts=selected(cart);if(!gifts.length||gifts.some(v=>!v))return '';return gifts.map((g,i)=>`Gift ${i+1}: ${g}`).join(' | ');}
  function stripGiftBlock(note='') {
    const raw=String(note||'');
    const start=raw.indexOf(NOTE_START);
    if(start===-1)return raw.trim();
    const end=raw.indexOf(NOTE_END,start+NOTE_START.length);
    if(end===-1)return raw.slice(0,start).trim();
    const before=raw.slice(0,start).trim();
    const after=raw.slice(end+NOTE_END.length).trim();
    return [before,after].filter(Boolean).join('\n\n');
  }
  function fulfillmentNote(cart) {
    const base=stripGiftBlock(cart?.note||'');
    const summary=packerSummary(cart);
    if(!summary)return base;
    const lines=summary.split(' | ');
    const block=[NOTE_START,'FREE GIFT TO PACK',...lines,NOTE_END].join('\n');
    return [base,block].filter(Boolean).join('\n\n');
  }
  async function syncPackerFresh(){
    if(packerSyncPromise)return packerSyncPromise;
    packerSyncPromise=(async()=>{
      let cart=await fetchCart();
      const desired=packerSummary(cart);
      const desiredNote=fulfillmentNote(cart);
      const current=String(cart?.attributes?.[PACKER_KEY]||'').trim();
      const currentNote=String(cart?.note||'').trim();
      if(current!==desired||currentNote!==desiredNote){
        cart=await updateCartState({[PACKER_KEY]:desired},desiredNote);
        cart=await fetchCart().catch(()=>cart);
      }
      lastCart=cart;renderProof(cart);return cart;
    })().finally(()=>{packerSyncPromise=null;});
    return packerSyncPromise;
  }
  function schedulePackerSync(delay=320){clearTimeout(syncTimer);syncTimer=setTimeout(()=>syncPackerFresh().catch(()=>{}),delay);}

  function proofHosts(){
    const hosts=[];
    const sheet=document.querySelector('.rr-cart-sheet__foot'); if(sheet) hosts.push({host:sheet,before:sheet.querySelector('.rr-cart-sheet__actions'),key:'sheet'});
    const full=document.querySelector('.rr-cart-summary'); if(full) hosts.push({host:full,before:full.querySelector('button[name="checkout"]'),key:'full'});
    return hosts;
  }
  function ensureProofs(){
    return proofHosts().map(({host,before,key})=>{
      let proof=host.querySelector(`.rr-gift-checkout-proof[data-rr-proof="${key}"]`);
      if(!proof){proof=document.createElement('section');proof.className='rr-gift-checkout-proof';proof.dataset.rrProof=key;if(before)host.insertBefore(proof,before);else host.append(proof);}return proof;
    });
  }
  function renderProof(cart){
    injectStyles(); lastCart=cart||lastCart; if(!cart)return;
    const proofs=ensureProofs(), count=earned(cart);
    if(!count){proofs.forEach(p=>p.remove());return;}
    const gifts=selected(cart), missing=firstMissing(cart);
    proofs.forEach(proof=>{
      proof.classList.toggle('is-missing',!!missing);
      if(missing){proof.innerHTML=`<p class="rr-gift-checkout-proof__eyebrow">FREE GIFT REQUIRED</p><p class="rr-gift-checkout-proof__title">Choose your free 2 oz before checkout.</p><p class="rr-gift-checkout-proof__note">Your gift must be saved before you continue.</p><button type="button" class="rr-gift-checkout-proof__choose" data-rr-proof-choose>Choose my free gift</button>`;return;}
      const items=gifts.map(g=>`<li>✓ ${escapeHtml(g)}</li>`).join('');
      proof.innerHTML=`<p class="rr-gift-checkout-proof__eyebrow">FREE GIFT ADDED TO YOUR ORDER</p><p class="rr-gift-checkout-proof__title">${gifts.length===1?'Your free 2 oz is confirmed.':`${gifts.length} free 2 oz gifts are confirmed.`}</p><ul class="rr-gift-checkout-proof__list">${items}</ul><p class="rr-gift-checkout-proof__note">It is a $0.00 item on this order and is sent directly to fulfillment.</p>`;
    });
  }
  async function renderFresh(cart=null){try{const current=cart||await fetchCart();lastCart=current;renderProof(current);}catch{}}
  function navigateCheckout(href='/checkout'){try{if(window.top&&window.top!==window)window.top.location.assign(href);else window.location.assign(href);}catch{window.location.assign(href);}}
  function checkoutTarget(node){return node?.closest?.('.rr-cart-sheet__checkout,[data-rr-cart] button[name="checkout"],#checkout-submit')||null;}
  function setCheckoutBusy(flag){checkoutBusy=flag;document.querySelectorAll('.rr-cart-sheet__checkout,[data-rr-cart] button[name="checkout"],#checkout-submit').forEach(el=>{if(flag)el.setAttribute('data-rr-checkout-busy','true');else el.removeAttribute('data-rr-checkout-busy');});}
  async function processCheckout(href='/checkout'){
    if(checkoutBusy)return; setCheckoutBusy(true);
    try{
      let cart=await fetchCart();lastCart=cart;
      let missing=firstMissing(cart);
      if(earned(cart)>0&&missing){renderProof(cart);window.RRCaseGift?.open?.(cart,missing);return;}

      if(window.RRCaseGift?.reconcile){
        const result=await window.RRCaseGift.reconcile(cart,{openIfNeeded:false});
        cart=result?.cart||await fetchCart();
        lastCart=cart;
      }

      missing=firstMissing(cart);
      if(earned(cart)>0&&missing){renderProof(cart);window.RRCaseGift?.open?.(cart,missing);return;}

      const giftLineCount=typeof window.RRCaseGift?.giftLines==='function' ? window.RRCaseGift.giftLines(cart).length : 0;
      if(earned(cart)>0&&giftLineCount!==earned(cart))throw new Error('Free gift line item was not saved');

      cart=await syncPackerFresh();missing=firstMissing(cart);
      if(earned(cart)>0&&missing){renderProof(cart);window.RRCaseGift?.open?.(cart,missing);return;}
      if(earned(cart)>0&&!packerSummary(cart))throw new Error('Gift fulfillment instruction was not saved');
      navigateCheckout(href);
    }catch{
      if(lastCart&&earned(lastCart)>0){renderProof(lastCart);return;}
      navigateCheckout(href);
    }finally{setCheckoutBusy(false);}
  }

  document.addEventListener('click',event=>{
    const choose=event.target.closest?.('[data-rr-proof-choose]');
    if(choose){event.preventDefault();fetchCart().then(cart=>{lastCart=cart;window.RRCaseGift?.open?.(cart,firstMissing(cart)||1);}).catch(()=>{});return;}
    const target=checkoutTarget(event.target);if(!target)return;
    if(target.getAttribute('aria-disabled')==='true'||checkoutBusy){event.preventDefault();event.stopImmediatePropagation();return;}
    event.preventDefault();event.stopImmediatePropagation();processCheckout(target.getAttribute('href')||'/checkout');
  },true);
  document.addEventListener('submit',event=>{
    const submitter=event.submitter;
    if(!submitter||!checkoutTarget(submitter))return;
    event.preventDefault();event.stopImmediatePropagation();processCheckout('/checkout');
  },true);

  document.addEventListener('rr:cart-rendered',event=>renderFresh(event.detail?.cart));
  document.addEventListener('rr:cart-updated',event=>{renderFresh(event.detail?.cart);schedulePackerSync(event.detail?.source==='gift-selection'?100:300);});
  document.addEventListener('rr:gift-close',()=>schedulePackerSync(80));
  window.addEventListener('pageshow',()=>{renderFresh();schedulePackerSync(350);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{renderFresh();schedulePackerSync(400);},{once:true});else{renderFresh();schedulePackerSync(400);}
})();
